module.exports = __webpack_public_path__ + "img/bookmarked.26554516.svg";